import React from "react";
import styled from "styled-components";
export interface IconProps {
	name: string;
	color?: string;
	size?: number;
	className?: string;
}

const SvgWrapper = styled.svg`
	/* width: 100%; */
`;

export const Icon: React.FC<IconProps> = ({ name, color = "white", size = 24, className }) => {
	return (
		<SvgWrapper xmlns="http://www.w3.org/2000/svg" width={`${size}`} height={`${size}`} viewBox={`0 0 24 24`} className={className}>
			{renderIcon(name, color)}
		</SvgWrapper>
	);
};

const renderIcon = (name: string, color: string) => {
	switch (name) {
		case "search": {
			return (
				<g transform="translate(-278 -2285)">
					<path d="M3229.5,11.5l5,5Zm-10.5-5a5.5,5.5,0,1,1,5.5,5.5A5.5,5.5,0,0,1,3219,6.5Z" transform="translate(-2937 2288)" fill="none" stroke={color} strokeWidth="2" />
				</g>
			);
		}
		case "list": {
			return (
				<g transform="translate(-229 -2285)">
					<path id="패스_1847" data-name="패스 1847" d="M160,155.934h12.615" transform="translate(78.115 2146.982)" fill="none" stroke={color} strokeWidth="2" />
					<path id="패스_1851" data-name="패스 1851" d="M160,155.934h12.615" transform="translate(78.115 2140.982)" fill="none" stroke={color} strokeWidth="2" />
					<path id="패스_1852" data-name="패스 1852" d="M160,155.934h12.615" transform="translate(78.115 2134.982)" fill="none" stroke={color} strokeWidth="2" />
					<path id="패스_1848" data-name="패스 1848" d="M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z" transform="translate(233 2290)" fill="none" stroke={color} strokeWidth="2" />
					<path id="패스_1849" data-name="패스 1849" d="M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z" transform="translate(233 2296)" fill="none" stroke={color} strokeWidth="2" />
					<path id="패스_1850" data-name="패스 1850" d="M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z" transform="translate(233 2302)" fill="none" stroke={color} strokeWidth="2" />
				</g>
			);
		}
		case "pluse": {
			return (
				<g transform="translate(-153 -2285)">
					<path d="M120,112v16m8-8H112" transform="translate(45.5 2177.5)" fill="none" stroke={color} strokeLinejoin="round" strokeWidth="2" />
				</g>
			);
		}
		case "close": {
			return (
				<g transform="translate(-193 -2285)">
					<path d="M158,158l-14-14m14,0-14,14" transform="translate(54.5 2146.5)" fill="none" stroke={color} strokeLinejoin="round" strokeWidth="2" />
				</g>
			);
		}
		case "minus": {
			return (
				<g id="ic_minus" transform="translate(-153 -2285)">
					<path d="M128,120H112" transform="translate(45.5 2177.5)" fill="none" stroke={color} strokeLinejoin="round" strokeWidth="2" />
				</g>
			);
		}
		case "right": {
			return (
				<g id="ic_right" transform="translate(-160 -2394)">
					<path d="M184,112l8,8-8,8" transform="translate(-14.5 2286.5)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
				</g>
			);
		}
		case "project": {
			return (
				<g transform="translate(-221 -2326)">
					<path
						fill={color}
						d="M2.624-4.864l1.84-2.944c.336-.64.656-1.3.944-1.92h.064c-.032.688-.1,1.76-.1,2.448v2.416Zm6.352,0H7.568V-11.84H4.752L.336-4.672v1.6h5.04V0H7.568V-3.072H8.976ZM10.112,0h7.936V-1.984H15.472c-.544,0-1.328.064-1.92.128,2.16-2.112,3.936-4.416,3.936-6.56a3.473,3.473,0,0,0-3.728-3.648A4.8,4.8,0,0,0,10-10.272l1.28,1.28a3.067,3.067,0,0,1,2.176-1.216,1.7,1.7,0,0,1,1.776,1.92c0,1.824-1.9,4.048-5.12,6.928Z"
						transform="translate(223.664 2344.064)"
					/>
				</g>
			);
		}
		case "facebook": {
			return (
				<g transform="translate(-283 -2394)">
					<path
						fill={color}
						d="M14.625,0A3.252,3.252,0,0,1,17.01.99,3.248,3.248,0,0,1,18,3.375v11.25A3.38,3.38,0,0,1,14.625,18h-2.2V11.027h2.332l.351-2.719H12.422V6.574a1.5,1.5,0,0,1,.275-.984,1.368,1.368,0,0,1,1.073-.328L15.2,5.25V2.824a15.708,15.708,0,0,0-2.086-.105,3.481,3.481,0,0,0-2.549.937A3.543,3.543,0,0,0,9.609,6.3v2H7.265v2.719H9.609V18H3.375A3.252,3.252,0,0,1,.99,17.01,3.248,3.248,0,0,1,0,14.625V3.375A3.252,3.252,0,0,1,.99.99,3.248,3.248,0,0,1,3.375,0Z"
						transform="translate(286 2397)"
					/>
				</g>
			);
		}
		case "instagram": {
			return (
				<g transform="translate(-347 -2415)">
					<path
						fill={color}
						d="M12,3c-2.444,0-2.75.011-3.71.054A6.623,6.623,0,0,0,6.1,3.473,4.6,4.6,0,0,0,3.472,6.1a6.636,6.636,0,0,0-.419,2.184C3.01,9.249,3,9.555,3,12s.01,2.75.054,3.71a6.623,6.623,0,0,0,.419,2.184,4.6,4.6,0,0,0,2.633,2.633,6.636,6.636,0,0,0,2.184.419C9.25,20.989,9.556,21,12,21s2.75-.011,3.71-.054a6.623,6.623,0,0,0,2.184-.419,4.6,4.6,0,0,0,2.633-2.633,6.636,6.636,0,0,0,.419-2.184c.043-.96.054-1.267.054-3.71s-.011-2.75-.054-3.71A6.623,6.623,0,0,0,20.527,6.1a4.6,4.6,0,0,0-2.633-2.633,6.636,6.636,0,0,0-2.184-.419C14.75,3.011,14.444,3,12,3m0,1.622c2.4,0,2.687.009,3.636.052a5,5,0,0,1,1.672.31,2.979,2.979,0,0,1,1.708,1.708,4.994,4.994,0,0,1,.31,1.671c.043.95.052,1.233.052,3.637s-.009,2.687-.052,3.636a5.032,5.032,0,0,1-.31,1.672,2.979,2.979,0,0,1-1.708,1.708,4.994,4.994,0,0,1-1.671.31c-.949.043-1.233.052-3.637.052s-2.688-.009-3.636-.052a5.032,5.032,0,0,1-1.672-.31,2.979,2.979,0,0,1-1.708-1.708,4.963,4.963,0,0,1-.31-1.671c-.043-.95-.052-1.233-.052-3.637s.009-2.687.052-3.636a5,5,0,0,1,.31-1.672A2.979,2.979,0,0,1,6.692,4.983a4.963,4.963,0,0,1,1.671-.31C9.312,4.631,9.6,4.622,12,4.622M12,15a3,3,0,1,1,3-3,3,3,0,0,1-3,3m0-7.621A4.621,4.621,0,1,0,16.621,12,4.621,4.621,0,0,0,12,7.379M17.883,7.2a1.08,1.08,0,1,1-1.08-1.08,1.08,1.08,0,0,1,1.08,1.08"
						transform="translate(347 2415)"
						fillRule="evenodd"
					/>
				</g>
			);
		}
		case "twitter": {
			return (
				<g transform="translate(-383 -2410)">
					<path
						fill={color}
						d="M20,1.924a8.308,8.308,0,0,1-2.05,2.119q.012.235.012.531a11.786,11.786,0,0,1-1.946,6.452A12.466,12.466,0,0,1,13.668,13.7a10.471,10.471,0,0,1-3.277,1.856,11.968,11.968,0,0,1-4.1.692A11.421,11.421,0,0,1,0,14.4a8.872,8.872,0,0,0,.979.057,8.045,8.045,0,0,0,5.1-1.758,3.981,3.981,0,0,1-2.383-.819,4.033,4.033,0,0,1-1.448-2.03A4.1,4.1,0,0,0,4.1,9.784,4,4,0,0,1,1.742,8.37,3.97,3.97,0,0,1,.806,5.762V5.712a4.049,4.049,0,0,0,1.859.513A4.076,4.076,0,0,1,1.332,4.763,4,4,0,0,1,.839,2.812,4.031,4.031,0,0,1,1.394.75,11.683,11.683,0,0,0,5.135,3.778,11.4,11.4,0,0,0,9.85,5.038,4.012,4.012,0,0,1,9.742,4.1a3.953,3.953,0,0,1,1.2-2.9,4.1,4.1,0,0,1,5.9.092,8.172,8.172,0,0,0,2.6-1,3.967,3.967,0,0,1-1.8,2.27A8.2,8.2,0,0,0,20,1.924Z"
						transform="translate(385 2414)"
					/>
				</g>
			);
		}
		case "link": {
			return (
				<g transform="translate(-271 -2324)">
					<path d="M7.995-2.255v4A4,4,0,0,1,0,1.748v-4" transform="translate(279.745 2332) rotate(90)" fill="none" stroke={color} strokeWidth="2" />
					<path d="M7.995-2.255v4A4,4,0,0,1,0,1.748v-4" transform="translate(286.255 2339.995) rotate(-90)" fill="none" stroke={color} strokeWidth="2" />
					<path d="M-2941,2336h8" transform="translate(3220)" fill="none" stroke={color} strokeWidth="2" />
				</g>
			);
		}
		case "space": {
			return (
				<g id="ic_space" transform="translate(-210 -2394)">
					<g id="planet-outline" transform="translate(196.002 2302.903)">
						<path
							d="M32.559,115.355c2.453,1.966,3.817,3.7,3.346,4.517-.744,1.284-5.782-.228-11.254-3.377s-9.3-6.743-8.562-8.026c.465-.8,2.607-.513,5.485.586"
							transform="translate(0 -11.244)"
							fill="none"
							stroke={color}
							strokeMiterlimit="10"
							strokeWidth="2"
						/>
						<ellipse
							id="타원_34"
							data-name="타원 34"
							cx="6.903"
							cy="6.933"
							rx="6.903"
							ry="6.933"
							transform="translate(19.149 96.097)"
							fill="none"
							stroke={color}
							strokeMiterlimit="10"
							strokeWidth="2"
						/>
					</g>
				</g>
			);
		}
		case "arduino": {
			return (
				<g>
					<path
						fill={color}
						d="M17,6c-2.1,0-3.9,1.1-5,2.7C10.9,7.1,9.1,6,7,6c-3.3,0-6,2.7-6,6s2.7,6,6,6c2.1,0,3.9-1.1,5-2.7c1.1,1.6,2.9,2.7,5,2.7
		c3.3,0,6-2.7,6-6S20.3,6,17,6z M7,16c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4s4,1.8,4,4C11,14.2,9.2,16,7,16z M17,16c-2.2,0-4-1.8-4-4
		c0-2.2,1.8-4,4-4s4,1.8,4,4C21,14.2,19.2,16,17,16z"
					/>
					<path fill={color} d="M9,11H5c-0.6,0-1,0.4-1,1s0.4,1,1,1h4c0.6,0,1-0.4,1-1S9.6,11,9,11z" />
					<path
						fill={color}
						d="M19,11h-1v-1c0-0.6-0.4-1-1-1s-1,0.4-1,1v1h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1v1c0,0.6,0.4,1,1,1s1-0.4,1-1v-1h1
		c0.6,0,1-0.4,1-1S19.6,11,19,11z"
					/>
				</g>
			);
		}

		case "bag": {
			return (
				<g>
					<path
						fill={color}
						d="M21,6h-4.1c-0.5-2.3-2.5-4-4.9-4S7.6,3.7,7.1,6H3C2.4,6,2,6.4,2,7v12c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V7
			 C22,6.4,21.6,6,21,6z M12,4c1.3,0,2.4,0.8,2.8,2H9.2C9.6,4.8,10.7,4,12,4z M20,8v2H4V8H20z M4,18v-6h16v6H4z"
					/>
				</g>
			);
		}
		case "date": {
			return (
				<g>
					<path
						fill={color}
						d="M21,4h-3V3c0-0.6-0.4-1-1-1s-1,0.4-1,1v1H8V3c0-0.6-0.4-1-1-1S6,2.4,6,3v1H3C2.4,4,2,4.4,2,5v16c0,0.6,0.4,1,1,1h18
		c0.6,0,1-0.4,1-1V5C22,4.4,21.6,4,21,4z M20,6v2H4V6H20z M4,20V10h16v10H4z"
					/>
					<path fill={color} d="M8,11H6c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1S8.6,11,8,11z" />
					<path fill={color} d="M13,11h-2c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1S13.6,11,13,11z" />
				</g>
			);
		}
		case "document": {
			return (
				<g>
					<path fill={color} d="M14.4,3H5v18h14l0-13.9L14.4,3z M17,19H7V5h6.6L17,8V19z" />
					<path fill={color} d="M8,13c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1s-0.4-1-1-1H9C8.4,12,8,12.4,8,13z" />
					<path fill={color} d="M15,15H9c-0.6,0-1,0.4-1,1s0.4,1,1,1h6c0.6,0,1-0.4,1-1S15.6,15,15,15z" />
				</g>
			);
		}
		case "location": {
			return (
				<g transform="translate(-275 -2476)">
					<path
						fill={color}
						id="location-outline"
						d="M10.854,1.713a5.11,5.11,0,0,1,5.14,4.8c0,2.65-2.136,6.11-5.14,10.847-3-4.737-5.14-8.2-5.14-10.847a5.11,5.11,0,0,1,5.14-4.8m0-1.713A6.813,6.813,0,0,0,4,6.513c0,3.6,2.972,7.89,6.854,14.049,3.882-6.158,6.854-10.452,6.854-14.049A6.812,6.812,0,0,0,10.854,0Zm0,9.424a2.57,2.57,0,1,1,2.57-2.57A2.57,2.57,0,0,1,10.854,9.424Z"
						transform="translate(276.504 2478.256)"
					/>
				</g>
			);
		}
		case "movement": {
			return (
				<path
					fill={color}
					d="M22,10.6c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2
	c0,0,0-0.1-0.1-0.1l-7.2-7.2c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L17.3,8l-6.8-2.3c-0.4-0.1-0.9,0-1.2,0.4C9.1,6.6,9.2,7.1,9.5,7.4
	l4.2,4.2L7,9.4C6.5,9.2,6,9.4,5.8,9.8c-0.2,0.4-0.2,0.9,0.1,1.2l4.2,4.2L3.4,13c-0.4-0.1-0.9,0-1.2,0.4C2,13.8,2,14.3,2.3,14.6
	l7.2,7.2c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4l-4.2-4.2l6.8,2.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0
	c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2
	c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2
	c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1l-4.2-4.2l6.8,2.3c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0
	c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0,0
	c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1L13.9,9l6.8,2.3
	c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1
	c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.2C21.9,10.8,21.9,10.7,22,10.6C22,10.6,22,10.6,22,10.6z"
				/>
			);
		}
		case "person": {
			return (
				<g>
					<path
						fill={color}
						d="M22,20c-0.9-4.1-5.8-6-10-6c-4.1,0-9,1.9-10,6c-0.1,0.4,0,0.9,0.2,1.3c0.2,0.4,0.6,0.6,1.1,0.7c0.2,0,0.3,0,0.5,0h16.4
		c0,0,0.1,0,0.1,0c0.8,0,1.6-0.6,1.7-1.5C22,20.4,22,20.2,22,20z M4.1,20c0.9-2.7,4.7-4,7.9-4c3.2,0,7,1.3,7.9,4H4.1z"
					/>
					<path fill={color} d="M12,13c2.8,0,5-2.2,5-5s-2.2-5-5-5S7,5.2,7,8S9.2,13,12,13z M12,5c1.7,0,3,1.3,3,3s-1.3,3-3,3S9,9.7,9,8S10.3,5,12,5z" />
				</g>
			);
		}
		case "price": {
			return (
				<g>
					<path
						fill={color}
						d="M21,5H3C2.4,5,2,5.4,2,6v12c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V6C22,5.4,21.6,5,21,5z M20,7v1.4H4V7H20z M4,17v-6.6h16V17
		H4z"
					/>
					<path fill={color} d="M8,14H6c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1S8.6,14,8,14z" />
				</g>
			);
		}
		case "time": {
			return (
				<g>
					<path
						fill={color}
						d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10C22,6.5,17.5,2,12,2z M12,20c-4.4,0-8-3.6-8-8s3.6-8,8-8
		s8,3.6,8,8S16.4,20,12,20z"
					/>
					<path fill={color} d="M17.8,11H13V6.2c0-0.6-0.4-1-1-1s-1,0.4-1,1V12c0,0.6,0.4,1,1,1h5.8c0.6,0,1-0.4,1-1S18.3,11,17.8,11z" />
				</g>
			);
		}

		case "touchdesigner": {
			return (
				<g>
					<path
						fill={color}
						d="M11.3,15.2c-2.1,0.1-3.7,1.8-3.6,3.9c-0.1,2,1.5,3.8,3.6,3.9h0c0,0,0,0,0,0c2.1-0.1,3.6-1.8,3.6-3.9c0,0,0,0,0,0
		C14.9,17,13.3,15.3,11.3,15.2z"
					/>
					<path
						fill={color}
						d="M20.7,10.6c0-0.1,0-0.2-0.1-0.3c-0.6-1.8-2.5-2.9-4.4-2.3c-0.6,0.2-1.3,0.4-1.9,0.6c-1.5,0.3-2.1,0-2.6-1.5
		c-0.3-0.8-0.5-1.6-0.7-2.3C10.6,3.1,9.2,2.1,7.7,2C6.2,2,4.9,2.9,4.4,4.2C3.7,5.7,3.9,7.3,4.9,8.5c0.8,1.2,2.3,1.7,3.7,1.2
		c0.7-0.2,1.4-0.5,2.2-0.6c1.2-0.3,1.9,0.1,2.4,1.4c0.3,0.8,0.5,1.5,0.7,2.3l0,0c0.4,1.6,1.8,2.8,3.4,2.9c0.4,0,0.7-0.1,1-0.2
		C20.3,14.8,21.3,12.6,20.7,10.6z"
					/>
				</g>
			);
		}
		case "check": {
			return (
				<g id="ic_check" transform="translate(-288 -2528)">
					{/* <rect id="사각형_156" data-name="사각형 156" width="24" height="24" transform="translate(288 2528)" fill="#fff" opacity="0" /> */}
					<path d="M-2906.072,2537.11l-11.21,17.9-4.893-7.474" transform="translate(3213.888 -6.087)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
				</g>
			);
		}
		case "left": {
			return (
				<g>
					<path d="M192,112l-8,8,8,8" transform="translate(-177.5 -107.5)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
				</g>
			);
		}

		default:
			return "";
	}
};
